import AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import router from "@/router/router.ts";
import type {StepperItem} from "@/domain/type/config.type.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import {Source} from "@/domain/type/source.type.ts";

export default class ProductConfig extends AbstractType {

  cleanFieldValue(value: string, label: string): string {
    return value;
  }

  getStepperItems(): StepperItem[] {
    return [
      {
        disabled: false,
        route: RouteEnum.SyncWithoutOwner,
        icon: "mdi-database",
        title: "Produits",
        action: () => router.push(this.getRoute(RouteEnum.SyncWithoutOwner))
      }
    ]
  }

  sourceLeftList(): Source[] {
    return [Source.EVA];
  }

  sourceRightList(): Source[] {
    return [Source.AMMON];
  }

  private getRoute(routeName: RouteEnum): any {
    switch (routeName) {
      case RouteEnum.SyncWithoutOwner:
        return {
          name: RouteEnum.SyncWithoutOwner,
          params: {
            type: SynchroType.PRODUCT,
          }
        }
    }
  }
}
